import { NgOptimizedImage } from '@angular/common';
import { Component, inject, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { RedirectRequest } from '@azure/msal-browser';
import { AuthService } from '../../services/auth.service';
import { RoutePath } from '../../enums/api.enum';

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    NgOptimizedImage
],
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {
  #authService = inject(AuthService);
  #msalService = inject(MsalService);
  #router = inject(Router);

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration
  ) { }

  ngOnInit(): void {
    /*
     * Subscribes to the MSAL service's handleRedirectObservable to handle authentication redirect results.
     * 
     * This method subscribes to the observable returned by the MSAL service's handleRedirectObservable method.
     * - If the result is successful, it navigates the user to the session path.
     * - If there is an error, it logs the error to the console.
     */
    this.#msalService.handleRedirectObservable().subscribe({
      next: (result) => {
        if (result) {
          this.#router.navigate([`/${RoutePath.Session}`]);
        }
      },
      error: (error) => {
        console.error(error);
      }
    });

    /*
     * Checks if there are any authenticated accounts and navigates to the session path if there are.
     * 
     * This method checks if there are any accounts authenticated with the MSAL service.
     * - If there is at least one authenticated account, it navigates the user to the session path.
     */
    if (this.#msalService.instance.getAllAccounts().length > 0) {
      this.#router.navigate([`/${RoutePath.Session}`]);
    }
  }

  /**
 * Handles the sign-in process for the user.
 * 
 * This method checks if there is an authentication request configuration set in the MSAL guard configuration.
 * - If an authentication request is specified, it initiates the sign-in process using that request.
 * - If no authentication request is specified, it initiates the default sign-in process.
 */
  onSignin() {
    // Take the authRequest set in the guard configurations into account.
    if (this.msalGuardConfig.authRequest) {
      this.#authService.signIn(this.msalGuardConfig.authRequest as RedirectRequest);
    } else {
      this.#authService.signIn();
    }

    // this.#msalService.logoutPopup().subscribe({
    //   next: () => {
    //     this.#router.navigate([`/${RoutePath.SignIn}`]);
    //   },
    //   error: (error) => {
    //     console.error(error);
    //     this.#router.navigate([`/${RoutePath.SignIn}`]);
    //   }
    // });
  }
}